/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/nlp-integration-api-client";
import type { GetLiveTopicsLatestTopicsQueryResponse, GetLiveTopicsLatestTopicsPathParams, GetLiveTopicsLatestTopicsQueryParams } from "../models/GetLiveTopicsLatestTopics";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getLiveTopicsLatestTopics } from "../axios/getLiveTopicsLatestTopics";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getLiveTopicsLatestTopicsQueryKey = (slug: GetLiveTopicsLatestTopicsPathParams["slug"], params: GetLiveTopicsLatestTopicsQueryParams = {}) => ["nlp-integration-api", { url: '/live-topics/:slug/topics/latest', params: {slug:slug} }, ...(params ? [params] : [])] as const

export type GetLiveTopicsLatestTopicsQueryKey = ReturnType<typeof getLiveTopicsLatestTopicsQueryKey>

export function getLiveTopicsLatestTopicsQueryOptions(slug: GetLiveTopicsLatestTopicsPathParams["slug"], params?: GetLiveTopicsLatestTopicsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getLiveTopicsLatestTopicsQueryKey(slug, params)
        return queryOptions<GetLiveTopicsLatestTopicsQueryResponse, ResponseErrorConfig<Error>, GetLiveTopicsLatestTopicsQueryResponse, typeof queryKey>({
         enabled: !!(slug),
         queryKey,
         queryFn: async ({ signal }) => {
            return getLiveTopicsLatestTopics(slug, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Return the latest topics for the channel, ordered by start_time descending.
 * @summary Get latest topics
 * {@link /live-topics/:slug/topics/latest}
 */
export function useGetLiveTopicsLatestTopics<TData = GetLiveTopicsLatestTopicsQueryResponse, TQueryData = GetLiveTopicsLatestTopicsQueryResponse, TQueryKey extends QueryKey = GetLiveTopicsLatestTopicsQueryKey>(slug: GetLiveTopicsLatestTopicsPathParams["slug"], params?: GetLiveTopicsLatestTopicsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetLiveTopicsLatestTopicsQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getLiveTopicsLatestTopicsQueryKey(slug, params)
         

         const query = useQuery({
          ...getLiveTopicsLatestTopicsQueryOptions(slug, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}